import React from "react";
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { ButtonProps } from "./types";
import { trackEvent } from "../../utils/posthog";

const Button: React.FC<ButtonProps> = ({ title, url, to, _target, onClick, active, location }) => {
  const track = (destination?: string, type?: "internal" | "external") =>
    trackEvent("cta_clicked", { label: title, destination, type, location });

  if (onClick) {
    return (
      <button
        className={`block transition-all cursor bg-brown-200 hover:bg-white text-white hover:text-brown-200 font-cursive font-normal uppercase py-3 px-8 rounded text-lg ${active && 'bg-black! text-white!'}`}
        onClick={() => {
          track();
          onClick();
        }}
      >
        {title}
      </button>
    );
  }
  return to ? (
    <AniLink
      paintDrip
      hex="#111"
      to={to}
      onClick={() => track(to, "internal")}
      className={`block transition-all cursor bg-brown-200 hover:bg-white text-white hover:text-brown-200 font-cursive font-normal uppercase py-3 px-8 rounded text-lg ${active && 'bg-black!'}`}
    >
      {title}
    </AniLink>
  ) : (
    <a
      href={url}
      onClick={() => track(url, "external")}
      className={`block transition-all cursor bg-brown-200 hover:bg-white text-white hover:text-brown-200 font-cursive font-normal uppercase py-3 px-8 rounded text-lg ${active && 'bg-black!'}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {title}
    </a>
  );
};

export default Button;
